<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <div class="bg-gradient-to-b from-[#F8F8F0] to-[#FDFDFB]">
    <section
      class="mx-auto grid max-w-screen-xl gap-x-10 gap-y-6 px-4 py-10 lg:grid-cols-2 lg:gap-y-20 lg:px-8"
    >
      <!-- Desktop -->
      <div class="grid place-content-center gap-y-5 text-center lg:max-w-xl lg:gap-y-10 lg:text-left">
        <h1 class="text-3xl font-medium lg:text-6xl">
          {{ t("home.section.hero.title") }}
        </h1>

        <i18n-t
          keypath="home.section.hero.description"
          tag="p"
          class="hidden text-balance text-xl lg:block"
        >
          <template #placeholder_2>
            <strong class="bold">
              {{ t("home.section.hero.placeholder_2") }}
            </strong>
          </template>

          <template #placeholder>
            <strong class="bold">
              {{ t("home.section.hero.placeholder") }}
            </strong>
          </template>
        </i18n-t>

        <UiButton as-child>
          <RouterLink
            :to="{ name: '/free-demo' }"
            class="group mx-auto hidden max-w-max lg:mx-0 lg:flex"
          >
            {{ t("home.section.hero.action.get_started") }}

            <UiIcon
              name="arrow-forward-rounded"
              class="transition-transform duration-200 group-hover:translate-x-1"
            />
          </RouterLink>
        </UiButton>
      </div>

      <div class="relative grid place-content-center">
        <UiImageWithOverlay
          :src="`${S3_ASSETS_URL}/home/hero.jpg`"
          container-class="lg:rounded-r-0 aspect-video max-h-[400px] rounded-[3.75rem] lg:rounded-l-[3.75rem] overflow-clip hidden md:block"
          class="aspect-square size-full object-cover"
          direction="to-left"
        />

        <div class="mt-0 min-h-[18.5rem] max-w-sm md:-ml-8 md:-mt-[30%] md:min-h-[19.5rem]">
          <HomePartialAIOMarketing class="isolate" />
        </div>
      </div>

      <!-- Mobile (duplicate) -->
      <div class="grid place-content-center gap-y-5 text-center lg:hidden lg:max-w-xl lg:gap-y-10 lg:text-left">
        <i18n-t
          keypath="home.section.hero.description"
          tag="p"
          class="text-balance text-base"
        >
          <template #placeholder_2>
            <strong class="bold">
              {{ t("home.section.hero.placeholder_2") }}
            </strong>
          </template>

          <template #placeholder>
            <strong class="bold">
              {{ t("home.section.hero.placeholder") }}
            </strong>
          </template>
        </i18n-t>

        <UiButton as-child>
          <RouterLink
            :to="{ name: '/free-demo' }"
            class="group mx-auto w-full max-w-xs lg:hidden"
          >
            {{ t("home.section.hero.action.get_started") }}
          </RouterLink>
        </UiButton>
      </div>

      <HomePartialBrandTicker class="!hidden lg:col-span-2 lg:!block" />
    </section>
  </div>
</template>
